module.exports = __webpack_public_path__ + "img/norway-infectious-diseases-male.c0024696.png";